import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";
export default class Empleados{

    getReportesLineas(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReporte_lineas.svc/RestService/GetReporteLineas")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getTiposFallos(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReporte_lineas.svc/RestService/GetTipoFalloActivos")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    Add(context,params){ 
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFReporte_lineas.svc/RestService/Add",params)        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
            t.$toast.add({
                severity:"error",
                summary:"ERROR",
                detail:"Error al obtener datos del servidor",
                life: 3000
            });
            console.log(error);
            reject(error);
            })
        })
    }

    Update(context,params){ 
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFReporte_lineas.svc/RestService/Update",params)        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
            t.$toast.add({
                severity:"error",
                summary:"ERROR",
                detail:"Error al obtener datos del servidor",
                life: 3000
            });
            console.log(error);
            reject(error);
            })
        })
    }

    Delete(context,params){ 
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFReporte_lineas.svc/RestService/Delete/" + params)        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
            t.$toast.add({
                severity:"error",
                summary:"ERROR",
                detail:"Error al obtener datos del servidor",
                life: 3000
            });
            console.log(error);
            reject(error);
            })
        })
    }
}